import Logo from "./Logo";

const Footer = () => (
  <footer className="border-t border-[#D3D7CF] bg-[#E8EAE3]/50 py-12" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-6">
      <div className="flex items-center gap-3">
        <Logo size={34} />
        <div>
          <p className="font-heading font-semibold text-[#2C402B]">Crochet Els</p>
          <p className="font-hand text-lg text-[#C27F67] leading-none">stitched with love</p>
        </div>
      </div>
      <p className="text-sm text-[#576956]" data-testid="footer-pricing">
        Scrunchies $5 · Bandanas $10
      </p>
      <p className="text-xs text-[#576956]/70">© {new Date().getFullYear()} Crochet Els. Handmade & one of a kind.</p>
      <a href="/login" className="text-xs font-semibold text-[#576956]/70 hover:text-[#2C402B] transition-colors" data-testid="footer-login-link">
        Owner login
      </a>
    </div>
  </footer>
);

export default Footer;
